export default {
    USER_ID :'user_RRbkAE4GNIDAdAvc0S6Dl',
    TEMPLATE_ID:'template_6s8dy7w',
    SERVICE_ID: 'service_uncvkv1'
}